// extracted by mini-css-extract-plugin
export default {"replay":"replay-oKyQEIhW"};